import Footer from '#src/components/Footer/index.js';
import Header from '#src/components/Header/index.js';
import LoginStatus from '#src/components/Header/LoginStatus';

import * as components from '../../../rows';
import {
  authenticateWithTokenIfPresent,
  requireAuthentication,
  requireAuthOrProspectEmail,
} from '../../routes/guards';

export const defaultNamespace = {
  darinsTestHero: { component: components.InterpolatedString }, // We're over our limit on contentful content models, so Interpolated String uses a repurposed existing but unused type, which has this unfortunate contentTypeId that cannot be changed (as far as I can tell)
  hubCallout: { component: components.Callout },
  hubComposableCallout: { component: components.ComposableCallout },
  hubFeature: { component: components.Feature },
  hubFinishRegistration: { component: components.FinishRegistration },
  // Rendered by the skyParallax namespace's Checkout. Kept here because
  // createRoutesMap reads route guards from the default namespace only.
  hubGameCheckout: { guards: [requireAuthOrProspectEmail] },
  hubGameDirectory: { component: components.GameDirectory },
  hubGameDetailScreenV2: {
    component: components.GameDetailScreenV2,
    guards: [authenticateWithTokenIfPresent],
  },
  hubGetApp: { component: components.GetApp },
  headerText: { component: components.HeaderText },
  hubHero: { component: components.Hero },
  hubHighlightedCallout: { component: components.HighlightedCallout },
  hubHighlightedRow: { component: components.HighlightedRow },
  hubHtml: { component: components.Html },
  hubLearnMore: { component: components.LearnMore },
  hubMembershipDetails: {
    component: components.MembershipDetails,
    guards: [requireAuthentication],
  },
  hubMembershipOffer: { component: components.MembershipOffer },
  hubParagraphText: { component: components.ParagraphText },
  hubPaybetSuccess: { component: components.PaybetSuccess },
  hubPartitionedCallout: { component: components.PartitionedCallout },
  hubPlainContent: { component: components.PlainContent },
  hubSimpleCta: { component: components.SimpleCta },
  hubPressLogos: { component: components.PressLogos },
  hubProductHero: { component: components.ProductHero },
  hubResponsiveHeroImage: { component: components.ResponsiveHeroImage },
  hubStats: { component: components.Stats },
  hubSvgIcon: { component: components.SvgIcon },
  hubTestimonialCarousel: { component: components.TestimonialCarousel },
  hubUserProfile: {
    component: components.UserProfile,
    guards: [requireAuthentication],
  },
  hubWaybetterWays: { component: components.WaybetterWay },
  hubAbContentRenderer: { component: components.ExpandableContent }, // We're over our limit on contentful content models, so ExpandableContent uses a repurposed existing but unused type that cannot be changed.

  pageWrapper: { component: 'div' },
  mainHeader: { component: Header },
  loginStatus: { component: LoginStatus },
  mainFooter: { component: Footer },
};
